
import React from 'react';
import AdsPageLayout from '../Components/AdsPage/AdsPageLayout';
import { adsPageConfigs, commonComparisonData, commonAdvantages } from '../Components/AdsPage/adsData';
import schemaAICI from "../Assets/Images/SchemaFacturation/SchemaAeCi.png";

export default function AeCiPageAds() {
  const config = adsPageConfigs.aeCi;
  
  // Données spécifiques pour cette page
  const comparisonData = [
    ...commonComparisonData.slice(0, 2), // Garde les 2 premiers éléments identiques
    {
      label: "Remboursement de 50% instantané",
      system: 0,
      aici: 1,
    },
    {
      label: "Avoir la main sur vos paiements",
      system: 0,
      aici: 1,
    },
    {
      label: "Vous ne gérez ni l'administratif ni la facturation",
      system: 0,
      aici: 1,
    },
  ];

  // Avantages spécifiques pour cette page
  const advantages = [
    {
      ...commonAdvantages[0],
      description: "L'élève, avant habitué à attendre l'année suivante pour récupérer 50% du montant déboursé, peut désormais payer uniquement la moitié de votre facture ! C'est une aubaine pour leur pouvoir d'achat, et ça leur permettra de prendre plus de cours qu'avant !"
    },
    ...commonAdvantages.slice(1) // Garde les autres avantages identiques
  ];

  return (
    <AdsPageLayout
      {...config}
      comparisonData={comparisonData}
      advantages={advantages}
      currentSituationImage={schemaAICI}
    />
  );
}
